'use strict';

import FormController from 'app/controllers/form';
//import raven from 'raven';
import AddSTController from './add-nested-st.controller';
import AddSTTpl from './add-nested-st.html';

import ConditionController from './condition.controller';
import ConditionTpl from './condition.html';

import { sortByProp } from '../../helpers/sorting';

function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    })
    .replace(/\s+/g, '');
}

interface Transition {
  from: any;
  label: string;
  to: string;
  end: boolean;
  immutable: boolean;
  index: number;
  triggers: any[] | null;
  ophs: any[];
  isCurrent: boolean | null;
  isCandidate: boolean | null;
  due: number | null;
}

export class TransitionsStore {
  index: number;
  state: string;
  _txs: Transition[];

  constructor(transitions, state = null) {
    this.state = state;
    this._txs = [
      {
        from: null,
        index: 0,
        to: 'start',
        label: 'Inicio',
        immutable: true,
        end: true,
        triggers: null,
        ophs: [],
        isCurrent: null,
        isCandidate: null,
        due: null
      }
    ];

    if (transitions) {
      if (transitions.length) this._txs[0].end = false;
      this._txs = this._txs.concat(transitions.sort(sortByProp('index')));
      //this.index = this._txs[this._txs.length - 1].index;
    }
  }

  getTransitions() {
    const txs = this._txs.map(tx => {
      if (!tx.from && typeof tx.index == 'number') {
        const parent = this._txs.find(t => t.index == tx.index - 1);
        tx.from = parent;
      }
      tx.ophs = [];
      return tx;
    });

    if (this.state) {
      // current tx
      const current = txs.find(tx => tx.to == this.state);
      current.isCurrent = true;

      // candidate
      if (!current.end) {
        const candidate = txs.find(tx => tx.index == current.index + 1);
        if (candidate) candidate.isCandidate = true;
      }
    }

    return txs;
  }

  getTransitionsForSaving() {
    return this._txs
      .map(tx => {
        const copy = Object.assign({}, tx);
        delete copy.from;
        delete copy.ophs;
        return copy;
      })
      .filter(tx => tx.to != 'start');
  }

  create(prevTx) {
    const tx: Transition = {
      label: 'Nuevo',
      end: false,
      from: null,
      index: prevTx.index + 1,
      triggers: [],
      ophs: [],
      isCurrent: null,
      isCandidate: null,
      to: '',
      immutable: false,
      due: null
    };
    prevTx.end = false;

    // Update index of the rest
    for (let i = tx.index; i <= this._txs.length - 1; i++) {
      this._txs[i].index++;
    }

    this._txs.push(tx);
    this._txs.sort(sortByProp('index'));
    this._txs[this._txs.length - 1].end = true;

    return tx;
  }

  remove(tx) {
    this._txs.splice(tx.index, 1);

    // update index of the rest
    for (let i = tx.index; i <= this._txs.length - 1; i++) {
      this._txs[i].index--;
    }

    this._txs[this._txs.length - 1].end = true;
  }
}

export default class StatesTemplateController extends FormController {
  $mdDialog: any;
  $state: any;
  model: any;
  StatesTemplatesService: any;
  AgenciesService: any;
  CreditorsService: any;
  txsStore: TransitionsStore;
  drawables: any[];
  statesTemplates: any[];
  showSpin: boolean;

  static $inject = [
    'StatesTemplatesService',
    'AgenciesService',
    'CreditorsService',
    '$scope',
    '$state',
    '$mdDialog'
  ];

  constructor(
    StatesTemplatesService,
    AgenciesService,
    CreditorsService,
    $scope,
    $state,
    $mdDialog
  ) {
    const statesTemplate = $scope.$parent.$resolve.statesTemplate;
    super(
      statesTemplate,
      'Tramite',
      StatesTemplatesService,
      null,
      'states-templates'
    );

    Object.assign(this, {
      StatesTemplatesService,
      AgenciesService,
      CreditorsService,
      $scope,
      $state,
      $mdDialog,
      statesTemplates: $scope.$parent.$resolve.statesTemplates
    });

    this.model = statesTemplate
      ? statesTemplate
      : this.StatesTemplatesService.create();

    this.txsStore = new TransitionsStore(this.model.transitions);
  }

  updateDrawables() {
    const drawing = this.txsStore.getTransitions();
    this.drawables = drawing;
  }

  $onInit() {
    this.updateDrawables();
  }

  onAddNewSTClick(tx) {
    this.$mdDialog
      .show({
        controller: AddSTController,
        template: AddSTTpl,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          statesTemplates: this.statesTemplates.filter(st =>
            this.model.id ? st.id != this.model.id : true
          )
        }
      })
      .then(st => {
        return this.$mdDialog
          .show({
            controller: ConditionController,
            template: ConditionTpl,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              services: {
                AgenciesService: this.AgenciesService,
                CreditorsService: this.CreditorsService
              }
            }
          })
          .then(condition => {
            this.addNewST(tx, st, condition);
          });
      });
  }

  addNewST(tx, st, condition) {
    if (!tx.triggers) {
      tx.triggers = [];
    }
    const newTrigger = {
      id: st.id,
      name: st.name,
      ...(condition ? { on: condition.on } : null),
      ...(condition ? { onLabel: condition.onLabel } : null)
    };
    tx.triggers.push(newTrigger);
  }

  onRemoveTriggerClick(tx, index) {
    tx.triggers.splice(index, 1);
  }

  addNewTransition(prevTx) {
    this.txsStore.create(prevTx);
    this.updateDrawables();
  }

  onRemoveTransitionClick(tx, $index) {
    this.txsStore.remove(tx);
    this.updateDrawables();
  }

  onTxChange(tx) {
    tx.to = camelize(tx.label);
    const from = typeof tx.from == 'string' ? tx.from : tx.from.to;
    tx.name = camelize(`${from} To ${tx.to}`);
  }

  beforeSave() {
    const txs = this.txsStore.getTransitionsForSaving();
    this.model.transitions = txs;
  }
}
